import { render } from "./Create.vue?vue&type=template&id=9f150d34&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=9f150d34&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=9f150d34&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f150d34"]])

export default __exports__